import { FacematchContext } from '@/context/facematch'
import FacematchService from '@/services/facematch'
import { useContext, useEffect } from 'react'
import Tab from '../ui/Tab'

export default function FacematchTabs() {
	const [facematch, facematchDispatch] = useContext(FacematchContext)

	useEffect(async () => {
		await FacematchService.GetStats()
			.then((data) => {
				facematchDispatch({
					type: 'SET_STATS',
					payload: {
						stats: data,
					},
				})
			})
			.catch(() => {})
		return () => {}
	}, [])

	function setCurrentTab(currentTab) {
		facematchDispatch({
			type: 'SET_CURRENT_TAB',
			payload: {
				tab: currentTab,
			},
		})
	}

	return facematch.tabs.map((tab) => {
		return (
			<Tab
				badge={facematch.stats[tab.key]}
				selectedKey={facematch.selectedTab.key}
				key={tab.key}
				item={tab}
				onClick={() => setCurrentTab(tab)}></Tab>
		)
	})
}
